export default function room() {

  $(window).on('scroll', function() {
    var pos = $('.studio-content').offset();
    var scrollTop = $(window).scrollTop();
    var headerH = $('#header').height();
    
    if (pos.top - scrollTop < headerH) {
      $('.room-info').addClass('sticky');
      $('.room-info').css('top', headerH);
    } else {
      $('.room-info').removeClass('sticky');
      $('.room-info').css('top', 'auto');
    }

    if ($(window).width() >= 768) {
      var images_pos = $('.room-images').offset();
      var images_height = $('.room-images').height();
      if (images_pos.top + images_height < scrollTop + $(window).height()) {
        $('.room-info').addClass('sticky-end');
        $('.room-info').removeClass('sticky');
      } else {
        $('.room-info').removeClass('sticky-end');
      }
    }
  });

  initContent();

  function initContent() {
    $('.accordion').accordion({
      "transitionSpeed": 400
    });
  
    $('.studio-content .details-nav a').click(function(e){
      e.preventDefault();
  
      $('.studio-content .details-nav a').removeClass('active');
      $(this).addClass('active');
      $('.studio-content .details-tab').hide();
      $($(this).attr('href')).show();
    });
  
    $('.room-images .item a').click(function(e){
      e.preventDefault();
      if ($(window).width() >= 768) {
        var carousel_pos = $(this).data('pos');
        $.magnificPopup.open({
          items: {
            src: '#gallery-popup', // can be a HTML string, jQuery object, or CSS selector
            type: 'inline'
          },
          callbacks: {
            open: function() {
              $('.gallery-container').trigger('to.owl.carousel', [carousel_pos, 0]);
            }
          }
        });
      }
    });

    $('.gallery-container').owlCarousel({
      items: 1,
      autoplay: false,
      loop: true,
      smartSpeed: 800,
      mouseDrag: true,
      touchDrag: true,
      nav: true
    });
  }

  $('.nav-room').click(function(e){
    e.preventDefault();
    $('.nav-room').toggleClass('open');
    $('#menu-studios-menu').toggleClass('open');
  });

  $('.nav-gallery').click(function(e){
    e.preventDefault();
    var pos = $('.room-images').offset().top;

    if ($('.room-info').hasClass('sticky')) {
      pos = pos - 120;
    } else {
      pos = pos - 200;
    }

    $('html, body').animate({
      scrollTop: pos
    }, 800);
  });

  $('#menu-studios-menu a').click(function(e){
    e.preventDefault();
    $('#menu-studios-menu li').removeClass('current-menu-item');
    $(this).parent().addClass('current-menu-item');
    $('.nav-room').text($(this).text());

    if ($(window).width() < 768) {
      $('.nav-room').toggleClass('open');
      $('#menu-studios-menu').toggleClass('open');
    }

    $.ajax({
      url: $(this).attr('href'),
      success: function(res){
        
        $('.studio-content').css('height', $('.studio-content').css('height'));

        $('.studio-content .details').fadeOut('1500', function(){
          $('.studio-content .details').html($(res).find('.studio-content .details').html());
          $('.studio-content .details').fadeIn('1500');
        });
        $('.studio-content .room-images').fadeOut('1500', function(){
          var pos = $('.studio-content').offset().top;

          $('html, body').animate({
            scrollTop: pos - $('#header').height() + 5
          }, 800);

          $('.studio-content .room-images').html($(res).find('.studio-content .room-images').html());
          $('.studio-content .room-images').fadeIn('1500');
          $('.studio-content').css('height', 'auto');

          initContent();
        });
        
      }
    });
  });

}